<div class="modal-side-panel" [class.open]="open">
    <div class="content-container">
        <ng-content></ng-content>
    </div>
</div>